import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';

const useStyles = makeStyles({
    card: {
        width: 'fit-content'
    },
});

export default function SerieProfile({ serie, setSerie }) {
    const classes = useStyles();

    const handleTrocaSerie = () => {
        setSerie(null)
    }

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <div style={{
                    display: 'flex'
                }}>
                    <div style={{
                        marginRight: '30px'
                    }}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Série
                        </Typography>
                        <Typography variant="body1" >
                            {serie.descricao}
                        </Typography>
                    </div>
                </div>
                <CardActions>
                    <Button
                        onClick={handleTrocaSerie}
                        size="small"
                        color="secondary"
                        variant="contained"
                    >Trocar Série</Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}